/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RoleMenuApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  //Add role pagination
  getRole(currentPage, pageSize, search, userRole): Observable<any> {
    return this.http.get(
      this.APIService +
        'roles/getRoles?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search +
        '&userRole=' +
        userRole
    );
  }

  getRoleById(roleId): Observable<any> {
    return this.http.get(
      `${this.APIService}roles/getRoleDetails?roleId=${roleId}`
    );
  }

  addRole(Payload): Observable<any> {
    return this.http.post(this.APIService + 'roles/saveRole', Payload);
  }

  updateRole(payload): Observable<any> {
    return this.http.post(this.APIService + 'roles/saveRole', payload);
  }

  deleteRole(roleId): Observable<any> {
    return this.http.delete(
      `${this.APIService}roles/deleteRole?roleId=${roleId}`
    );
  }

  getAllMenus(): Observable<any> {
    return this.http.get(this.APIService + 'menus/getMenus');
  }

  addPermission(payload): Observable<any> {
    return this.http.put(this.APIService + 'roles/save/role', payload);
  }
}
